export const ORIGINS = {
  BIO: "Bio",
  FES: "Festif",
  LOC: "Produit Local",
  MAI: "Fait Maison",
  QUA: "Produit Qualité",
  VEG: "Végétarien"
};

export const PRODUCT_TYPES = {
  STARTER: "ENT",
  MAIN: "PLA",
  DESSERT: "DES",
  SIDE: "ACC",
  CHEESE: "FRO",
};

export const PRODUCT_TYPES_NAMES = {
  [PRODUCT_TYPES.STARTER]: "Entrée",
  [PRODUCT_TYPES.MAIN]: "Plat",
  [PRODUCT_TYPES.DESSERT]: "Dessert",
  [PRODUCT_TYPES.CHEESE]: "Fromages/Laitages",
  [PRODUCT_TYPES.SIDE]: "Accompagnement"
};
